import styled from 'styled-components';

interface CardListProps {
  flex?: boolean;
  marginBottom?: string;
  role?: string;
}

export const CardList = styled.div<CardListProps>`
  display: ${({ flex }) => (flex ? 'flex' : 'grid')};
  gap: ${({ flex }) => (flex ? 0 : '0.7rem')};
  margin-bottom: ${({ marginBottom }) => marginBottom ?? 0};

  div {
    margin-right: ${({ flex }) => (flex ? '0.7rem' : 0)};
    &:last-of-type {
      margin-right: 0;
    }
  }
`;

export default CardList;
